//
// Javascript that creates and operates
// a standard-styled ajax table
//
//  BenRamey
//  March 2011
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.StandardAjaxTable = function (parent, options) {
  this._tableId = "standardajaxtable_" + HEIJS.Controls.StandardAjaxTable._nextId;
  this._table = $("table.standard-table", parent).length > 0
    ? $("table.standard-table", parent)
    : $("<table class='standard-table'>");
  this._table.attr("id", this._tableId);

  if ($("table.standard-table", parent).length == 0) {
    this._table.appendTo(parent); 
  }
  HEIJS.Controls.StandardAjaxTable._nextId++;

  // options that user can set when using this control
  $.extend(this, {
    columns: options.columns || {},
    columnWidths: options.columnWidths || {},
    commands: options.commands || null,
    dataServiceUrl: options.dataServiceUrl || null,
    showPagingRow: options.showPagingRow || false,
    rowsPerPage: options.rowsPerPage || 10,
    searchInput: options.searchInput || null,
    allowSelect: options.allowSelect || false,
    maxSelectAtOnce: options.maxSelectAtOnce || -1,
    methodIsParameter: options.methodIsParameter || false,
    requireSearch: options.requireSearch || false,
    ajaxType: options.ajaxType || "GET"
  });
  // events
  $.extend(this, {
    onInitService: options.onInitService || function () { },
    beforePageDataLoad: options.beforePageDataLoad || function () { },
    afterPageRowsCreated: options.afterPageRowsCreated || function () { },
    onAdjustCriteria: options.onAdjustCriteria || function (eventArgs) { return eventArgs.criteria; },
    onBuildDataRow: options.onBuildDataRow || function () { },
    onCreateCell: options.onCreateCell || null,
    onAdjustAjaxCallData: options.onAdjustAjaxCallData || function (eventArgs) { return eventArgs.data; }
  });

  this._table.append("<tbody><tr><td colspan='" + this.getNumColumns() + "'>Loading data...</td></tr></tbody>");

  this._criteria = { searchTerm: "", fields: { } };
  for (var key in this.columns) {
    this._criteria.fields[this.columns[key]] = "";
  }

  this.initService();
  this.createHeaders();
  this.createPagingRow();
  this.createRows();

  this.setupEvents();
};
HEIJS.Controls.StandardAjaxTable._nextId = 0;
HEIJS.Controls.StandardAjaxTable.prototype =
{
  //
  // properties
  //
  _table: null,
  _tableId: null,
  _currentPageNumber: 0, // zero-based number of current page (so, 1 in the ui corresponds to 0 here)
  _currentRowNumberOffset: 0,
  _currentPageData: null,
  _totalRowCount: -1,
  _criteria: null,
  _selectAllCB: null,

  //
  // methods
  //
  initService: function () {
    if (this.dataServiceUrl)
      this.dataServiceUrl = HEIJS.context.convertToContextUri(this.dataServiceUrl);

    this.onInitService({});
  },

  getPageData: function (pageNumber, callback) {
    var self = this;
    this.beforePageDataLoad({ pageNumber: pageNumber });

    var offset = pageNumber * this.rowsPerPage;
    if (isNaN(offset)) offset = 0;
    $.ajax({
      type: this.ajaxType,
      url: this.getAjaxCallUrl("GetPageData"),
      data: this.getAjaxCallData("GetPageData", { criteria: this.getCriteria(), offset: offset, pageSize: this.rowsPerPage }),
      success: function (data) { self._currentPageData = data || {}; callback(data); }
    });
  },

  getAjaxCallUrl: function (method) {
    return this.methodIsParameter
      ? this.dataServiceUrl 
      : (this.dataServiceUrl.indexOf('?') > 0 ? this.dataServiceUrl : this.dataServiceUrl + "?") +
      (this.ajaxType == "GET" ? method : "method=" + method);
  },

  getAjaxCallData: function (method, data) {
    var eventArgs = { data: data };
    this.onAdjustAjaxCallData(eventArgs);
    return this.ajaxType == "GET" 
      ? this.methodIsParameter ? $.extend(eventArgs.data, { method: method }) : eventArgs.data
      : JSON.stringify(this.methodIsParameter ? $.extend(eventArgs.data, { method: method }) : eventArgs.data);
  },

  getCriteria: function () {
    for (var key in this.columns) {
      this._criteria.fields[this.columns[key]] = this._criteria.searchTerm;
    }
    var eventArgs = { criteria: this._criteria };
    this.onAdjustCriteria(eventArgs);
    var criteria = {
      searchTerm: eventArgs.criteria.searchTerm,
      fields: HEIJS.objectToDictionary(eventArgs.criteria.fields)
    };
    return JSON.stringify(criteria);
  },

  createHeaders: function () {
    var self = this;

    // initialize headers only if they are not initialized already
    if ($("thead", self._table).length == 0) {
      var thead = $("<thead>");
      var theadRow = $("<tr>").appendTo(thead);

      if (this.allowSelect) {
        var selectAllCell = $("<th class='select-cell'></th>");
        theadRow.append(selectAllCell);
        if (this.maxSelectAtOnce == -1) {
          this._selectAllCB = $("<input type='checkbox' id='selectall'/>");
          selectAllCell.append(this._selectAllCB);

          this._selectAllCB.click(function() {
            var checkboxes = $("tbody td.select-cell input[type=checkbox]", self._table);

            if ($(this).is(":checked")) {
              checkboxes.prop("checked", true);
              $("tbody tr", self._table).addClass("selected");
            } else {
              checkboxes.prop("checked", false);
              $("tbody tr", self._table).removeClass("selected");
            }
          });
        }
      }

      for (var key in this.columns) {
        var headerCell = $("<th>" + key + "</th>");

        if (this.columnWidths[key])
          headerCell.width(this.columnWidths[key]);

        theadRow.append(headerCell);
      }

      if (this.commands) {
        var commandsCell = $("<th>&nbsp;</th>");

        if (this.columnWidths["Commands"])
          commandsCell.width(this.columnWidths["Commands"]);

        theadRow.append(commandsCell);
      }

      thead.prependTo(this._table);
    }
  },

  allowPageDataLoad: function () {
    return this._criteria.searchTerm !== "" || !this.requireSearch;
  },

  createRows: function () {
    var tbody = $("<tbody>");
    var self = this;
    if (this._currentPageData == null && this.allowPageDataLoad()) {
      this.getPageData(this._currentPageNumber, function () { self.createRows(); });
      return;
    }

    if (this._currentPageData && this._currentPageData.length != 0) {
      var rowCount = 0;
      for (var idx in this._currentPageData) {
        var row = $("<tr>");
        if (rowCount & 1)
          row.addClass("alt");

        if (this.allowSelect) {
          var selectCell = $("<td class='select-cell'><input type='checkbox'/></td>");
          row.append(selectCell);
        }

        for (var key in this.columns) {
          var cell = $("<td>");

          if (!this.onCreateCell || !this.onCreateCell({ key: key, cell: cell, data: this._currentPageData[idx] })) {
            cell.text(this._currentPageData[idx][this.columns[key]]);
          }

          row.append(cell);
        }

        if (this.commands) {
          var commandsCell = $("<td>");

          for (var commandName in this.commands) {
            var command = $("<a href='#'></a>");
            command.data(this._currentPageData[idx]);
            command.text(commandName);
            command.attr("command", commandName);
            command.click(function (e) {
              e.preventDefault();
              e.stopPropagation();
              self.commands[$(this).attr("command")].apply(this, [$(this).data()]);
            });

            commandsCell.append(command).append("&nbsp;");
          }

          row.append(commandsCell);
        }

        this.onBuildDataRow({ row: row, data: this._currentPageData[idx] });

        tbody.append(row);
        rowCount++;
      }
    }
    else if (!this.allowPageDataLoad()) {
      tbody.append("<tr><td colspan='" + this.getNumColumns() + "'>Enter search criteria to see results</td></tr>");
    }
    else {
      tbody.append("<tr><td colspan='" + this.getNumColumns() + "'>No data was found</td></tr>");
    }

    this._table.find("tbody").remove();
    tbody.appendTo(this._table);

    this.updatePagingRow();
    if (this.searchInput)
      this.searchInput.focus();

    this.afterPageRowsCreated({});
  },

  getNumColumns: function () {
    var numColumns = 0;
    for (var key in this.columns) numColumns++;
    if (this.commands) numColumns++;
    if (this.allowSelect) numColumns++;
    return numColumns;
  },

  getTotalRowCount: function (callback) {
    var self = this;
    $.ajax({
      type: this.ajaxType,
      url: this.getAjaxCallUrl("GetTotalRowCount"),
      data: this.getAjaxCallData("GetTotalRowCount", { criteria: this.getCriteria() }),
      success: function (data) { self._totalRowCount = data || 0; callback(data); }
    });
  },

  performSearch: function (searchString) {
    if (searchString == "" && this.requireSearch) {
      this._criteria.searchTerm = "";
      this.refresh(null);
      return;
    }

    var localStatus = HEIJS.page.systemStatus.showLocal("Searching", this._table);
    var self = this;
    this._criteria.searchTerm = searchString;

    $.ajax({
      type: this.ajaxType,
      url: this.getAjaxCallUrl("GetPageData"),
      data: this.getAjaxCallData("GetPageData", { criteria: this.getCriteria(), offset: 0, pageSize: this.rowsPerPage }),
      success: function (data) {
        self.refresh(data || []);
        localStatus.remove();
      }
    });
  },

  refresh: function (data) {
    this._totalRowCount = -1;
    this._currentPageData = data;
    this._currentPageNumber = 0;
    if (this._selectAllCB) this._selectAllCB.prop("checked", false);
    this.createRows();
  },

  updatePagingRow: function () {
    if (!this.showPagingRow)
      return;

    if (!this.allowPageDataLoad())
      this._totalRowCount = 0;

    if (this._totalRowCount < 0) {
      var self = this;
      this.getTotalRowCount(function () { self.updatePagingRow(); });
      return;
    }

    var pagingCell = $("td.paging", this._table);
    pagingCell.children("span:first").text(this.getPagingText());
    pagingCell.find("input").val(this.getDisplayPageNumber());
  },

  getPagingText: function () {
    var pagingText = "Page " + this.getDisplayPageNumber()
                    + " of " + Math.ceil(this._totalRowCount / this.rowsPerPage)
                    + " (" + this._totalRowCount + " items) ";
    return pagingText;
  },

  getDisplayPageNumber: function () {
    return this._totalRowCount > 0 ? (this._currentPageNumber + 1) : 0;
  },

  createPagingRow: function () {
    if (!this.showPagingRow)
      return;

    if (!this.allowPageDataLoad())
      this._totalRowCount = 0;

    if (this._totalRowCount < 0) {
      this._table.find("tfoot").find("td").empty();
      var self = this;
      this.getTotalRowCount(function () { self.createPagingRow(); });
      return;
    }

    var tfoot = $("<tfoot>");
    var tfootRow = $("<tr>");

    var pagingCell = $("<td class='paging'>");
    pagingCell.attr("colspan", this.getNumColumns());

    var pagingTextSpan = $("<span>");
    pagingTextSpan.text(this.getPagingText());

    var pageInput = $("<input type='text'/>");
    pageInput.val(this.getDisplayPageNumber());

    pagingCell.append(pagingTextSpan);
    pagingCell.append("<span class='ui-icon ui-icon-carat-1-w'></span>");
    pagingCell.append(pageInput);
    pagingCell.append("<span class='ui-icon ui-icon-carat-1-e'></span>");

    tfootRow.append(pagingCell);
    tfoot.append(tfootRow);
    this._table.find("tfoot").remove();
    this._table.append(tfoot);

    var self = this;
    pageInput.change(function () { self.changePage(parseInt($(this).val()) - 1); });
    pageInput.keypress(function (e) { if (e.which == 13) self.changePage(parseInt($(this).val()) - 1); });
    pagingCell.find("span.ui-icon").click(function () {
      var pageNumber = $(this).is(".ui-icon-carat-1-w") ? self._currentPageNumber - 1 : self._currentPageNumber + 1;
      self.changePage(pageNumber);
    });
  },

  changePage: function (pageNumber) {
    var lastPage = Math.ceil(this._totalRowCount / this.rowsPerPage);

    if (lastPage == 1)
      return;

    pageNumber = pageNumber < 0 ? 0 : pageNumber;
    pageNumber = pageNumber >= lastPage ? lastPage - 1 : pageNumber;

    this._currentPageData = null;
    this._currentPageNumber = pageNumber;
    this.createRows();
  },

  setupEvents: function () {
    var self = this;
    if (this.searchInput) {
      this.searchInput.change(function () { self.performSearch($.trim($(this).val())); });
    }

    // check boxes for selecting a row
    if (this.allowSelect) {
      $("table#" + this._tableId + " tbody tr").on("click", function () {
        var checkbox = $("td.select-cell input", this);
        if ($(this).is(".selected"))
          checkbox.prop("checked", false);
        else
          checkbox.prop("checked", true);

        checkbox.change();
      });

      $("table#" + this._tableId + " td.select-cell input").on("change", function (e) {
        if ($(this).is(":checked")) {
          $(this).parents("tr:first").addClass("selected");

          if (self.maxSelectAtOnce == -1) {
            var allChecked = true;
            $("td.select-cell input", self._table).each(function () {
              if (!$(this).is(":checked")) {
                allChecked = false;
                return false;
              }
            });

            if (allChecked)
              self._selectAllCB.prop("checked", true);
          }
          else if (self.maxSelectAtOnce < self._table.find("tbody td.select-cell input:checked").length) {
            self._table.find("tbody td.select-cell input:checked")
              .not(this)
              .filter(":first")
              .prop("checked", false)
              .change();
          }
        }
        else {
          $(this).parents("tr:first").removeClass("selected");
          if (self._selectAllCB)
            self._selectAllCB.prop("checked", false);
        }
      });
    }

  }
};